module.exports = __webpack_public_path__ + "static/media/TUSA-Proud-tile-453x453.5ad3ee44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/TUSA-Proud-tile-453x453.jpg
// module id = 308
// module chunks = 0